
import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const DoubleWallPage = lazy(() => import('../pages/services/double-wall/page'));
const SingleWallPage = lazy(() => import('../pages/services/single-wall/page'));
const HermeticPage = lazy(() => import('../pages/services/hermetic/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const CertificatesPage = lazy(() => import('../pages/certificates/page'));
const CatalogPage = lazy(() => import('../pages/catalog/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/services',
    element: <ServicesPage />,
  },
  {
    path: '/services/double-wall',
    element: <DoubleWallPage />,
  },
  {
    path: '/services/single-wall',
    element: <SingleWallPage />,
  },
  {
    path: '/services/hermetic',
    element: <HermeticPage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/certificates',
    element: <CertificatesPage />,
  },
  {
    path: '/catalog',
    element: <CatalogPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
